
export function isYouTubeUrl(url) {
    if (!url) {
        return false;
    }
    var regExp = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gm;
    if (url.match(regExp)) {
        return true;
    }
    return false;
}